/**
 * Route-based promo code utility
 * Determines the appropriate promo code based on the current route
 */

import { PROMO_CODE } from "../config";

/**
 * Returns the appropriate promo code based on the current pathname
 * @param pathname - The current route pathname
 * @returns The promo code to use
 */
export const getRouteBasedPromoCode = (pathname: string): string => {
  // Awareness page (home) and Texas save page both use EIQPPC
  if (pathname === '/') {
    return 'EIQPPC';
  }

  if (pathname === '/state/tx/save' || pathname === '/state/tx/save/' || pathname === 'state/tx/save') {
    return 'EIQPPC';
  }

  return PROMO_CODE;
};

/**
 * Hook-friendly version that gets the current pathname and returns the appropriate promo code
 * @param pathname - Current pathname from useLocation or window.location.pathname
 * @returns The promo code to use for the current route
 */
export const getCurrentPromoCode = (pathname?: string): string => {
  const currentPath = pathname || (typeof window !== 'undefined' ? window.location.pathname : '/');
  return getRouteBasedPromoCode(currentPath);
};
